
class MessageFactory {
  activityId;
  content;
  media;
  direction;
  dateTime;
  error;
  uploadingFile;

  constructor({
    content,
    media,
    activityId,
    direction,
    dateTime,
    error,
    uploadingFile
    }) {
    this.content = content;
    this.media = media;
    this.activityId = activityId;
    this.direction = direction;
    this.dateTime = dateTime;
    this.error = error;
    this.uploadingFile = uploadingFile;
  }
}

export default MessageFactory;



// WEBPACK FOOTER //
// ./chat-app/services/messageFactory.js